import { useCallback, useEffect } from 'react';
import useServices from 'app/services';
import useConfig from 'app/config';
import { useAppState } from 'state';
import { MessageType } from 'app/utils/in-app-comunication/types';
import { useCommunicationService } from 'app/services/communication';
import { encodeAuthCode } from 'app/utils/in-app-comunication/auth-code';
import { isInIframe } from 'app/utils/in-app-comunication/utils';

const useAuthCode = () => {
  const comms = useCommunicationService();
  const services = useServices();
  const { config } = useConfig();
  const { signedIn, authorization, userId } = useAppState(({ auth }) => ({
    signedIn: auth.signedIn,
    authorization: auth.authorization,
    userId: auth.userId,
  }));

  const getAuthCode = useCallback(async () => {
    if (!signedIn || !authorization || !userId || !isInIframe()) {
      return;
    }

    try {
      const authCodeResponse = await services.auth.getAuthCode(
        config.REACT_APP_AUTH_CODE_NO_REDIRECT_URL,
        authorization,
        config.REACT_APP_AUTH_CLIENT_ID,
      );

      const message = {
        type: MessageType.AUTH_CODE_RECEIVED,
        authCode: encodeAuthCode({
          code: authCodeResponse.authorizationCode,
          codeVerifier: authCodeResponse.codeVerifier,
        }),
      };

      comms.sendMessage(message);
    } catch (error) {
      console.error('Failed to get auth code:', error);
    }
  }, [signedIn, authorization, userId, services.auth, config, comms]);

  // Get auth code on initial load when signed in and in iframe
  useEffect(() => {
    if (signedIn && authorization && userId && isInIframe()) {
      getAuthCode();
    }
  }, [signedIn, authorization, userId, getAuthCode]);

  return {
    getAuthCode,
  };
};

export default useAuthCode;
